import React from "react";
import { IconButton, InputAdornment, OutlinedInput, Typography, } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
const AppHeaderSearch = ({ value, placeholder, onChange, className = "app-header-search", inputProps, showClear = false, onClear, sx, matchCount, }) => {
    const [t] = useTranslation('global');
    const shouldShowClear = showClear && Boolean(value);
    const showMatchCount = Boolean(value) && matchCount !== undefined;
    const endAdornment = (showMatchCount || shouldShowClear) ? (React.createElement(InputAdornment, { position: "end", sx: { gap: 0.25 } },
        showMatchCount && (React.createElement(Typography, { component: "span", sx: {
                fontSize: "11px",
                fontWeight: 600,
                lineHeight: "14px",
                color: (matchCount !== null && matchCount !== void 0 ? matchCount : 0) > 0 ? "var(--color)" : "#9CA3AF",
                whiteSpace: "nowrap",
                mr: shouldShowClear ? 0.25 : 0,
                px: 0.75,
                py: 0.25,
                borderRadius: "4px",
                backgroundColor: (matchCount !== null && matchCount !== void 0 ? matchCount : 0) > 0
                    ? "color-mix(in srgb, var(--color) 10%, transparent)"
                    : "rgba(156,163,175,0.12)",
            } }, (matchCount !== null && matchCount !== void 0 ? matchCount : 0) > 0
            ? `${matchCount} ${matchCount === 1 ? t('GLOBAL_SEARCH.Match') : t('GLOBAL_SEARCH.Matches')}`
            : t('GLOBAL_SEARCH.NoMatches'))),
        shouldShowClear && (React.createElement(IconButton, { size: "small", "aria-label": "clear search", onClick: onClear },
            React.createElement(CloseIcon, { sx: { fontSize: 16, color: "#9CA3AF" } }))))) : undefined;
    return (React.createElement(OutlinedInput, { className: className, placeholder: placeholder, value: value, onChange: (e) => onChange(e.target.value), size: "small", inputProps: inputProps, startAdornment: React.createElement(InputAdornment, { position: "start", sx: { marginRight: '6px' } },
            React.createElement(SearchIcon, { sx: { fontSize: 16, color: "#6B7280" } })), endAdornment: endAdornment, sx: Object.assign({ fontSize: '12px', fontWeight: '400', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDC2' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9CA3AF' }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#9CA3AF', borderWidth: '1px' } }, sx) }));
};
export default React.memo(AppHeaderSearch);
